
import React from 'react'

import { ButtonGroupProps } from './ButtonGroup.types'

import './ButtonGroup.scss'

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  wrapperProps = {},
  disabled = false,
  children,
}) => {
  
  return (
    <div className={`btn-group ${disabled && 'btn-group-disabled'}`}
      {...wrapperProps}
    >
      {children}
    </div>
  )
}

export default ButtonGroup 